import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { getJournal } from "../lib/api";
import { Reveal } from "../components/Reveal";

const CATEGORIES = ["All", "Fitness", "Wellness", "Nutrition", "Recovery", "Style Guides", "Motivation", "Training Tips", "Lifestyle"];

export default function Journal() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "All";
  const [posts, setPosts] = useState([]);

  useEffect(() => { getJournal(category).then(setPosts); }, [category]);

  const featured = posts[0];
  const rest = posts.slice(1);

  return (
    <div data-testid="journal-page">
      <div className="container-luxe py-16 text-center">
        <p className="overline text-gold mb-3">The Journal</p>
        <h1 className="h-display text-5xl sm:text-7xl">Stories In Motion</h1>
        <p className="mt-5 text-sm text-muted-foreground font-light max-w-xl mx-auto">Fitness, wellness, and the art of moving with confidence — from the SV editorial team.</p>
      </div>

      <div className="container-luxe flex gap-3 overflow-x-auto no-scrollbar pb-8 justify-start lg:justify-center">
        {CATEGORIES.map((c) => (
          <button key={c} onClick={() => setParams(c === "All" ? {} : { category: c })} data-testid={`journal-cat-${c}`}
            className={`whitespace-nowrap px-5 py-2 text-xs font-display uppercase tracking-wide2 border transition-colors ${category === c ? "bg-charcoal text-bone border-charcoal" : "border-hairline hover:border-charcoal"}`}>{c}</button>
        ))}
      </div>

      {featured && (
        <section className="container-luxe py-8">
          <Reveal>
            <Link to={`/journal/${featured.slug}`} className="group grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-testid="journal-featured">
              <div className="aspect-[4/3] overflow-hidden bg-beige/40"><img src={featured.image} alt={featured.title} className="h-full w-full object-cover img-zoom" /></div>
              <div>
                <p className="overline text-gold mb-4">{featured.category} · {featured.read_time}</p>
                <h2 className="h-display text-4xl sm:text-5xl mb-5 group-hover:text-gold transition-colors">{featured.title}</h2>
                <p className="text-sm text-muted-foreground font-light leading-relaxed mb-6 max-w-lg">{featured.excerpt}</p>
                <span className="overline text-[11px] link-underline">Read Article</span>
              </div>
            </Link>
          </Reveal>
        </section>
      )}

      <section className="container-luxe py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {rest.map((post, i) => (
          <Reveal key={post.id} delay={(i % 3) * 0.08}>
            <Link to={`/journal/${post.slug}`} className="group block" data-testid={`journal-card-${post.slug}`}>
              <div className="aspect-[4/3] overflow-hidden bg-beige/40 mb-5"><img src={post.image} alt={post.title} className="h-full w-full object-cover img-zoom" /></div>
              <p className="overline text-[10px] text-gold mb-2">{post.category} · {post.read_time}</p>
              <h3 className="font-serif text-2xl mb-2 group-hover:text-gold transition-colors">{post.title}</h3>
              <p className="text-sm text-muted-foreground font-light leading-relaxed">{post.excerpt}</p>
            </Link>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
